import { styled } from '@f8n-frontend/stitches';

/**
 * @deprecated - use InputV3 instead
 */
const Input = styled('input', {
  fontFamily: '$body',
  lineHeight: '$0',
  minHeight: 54,
  display: 'flex',
  alignItems: 'center',
  borderRadius: '$round',
  appearance: 'none',
  paddingLeft: '$5',
  paddingRight: '$5',
  transition: '$1',
  transitionProperty: 'box-shadow',
  fontWeight: '$regular',
  fontSize: '$2',

  '&:focus': {
    outline: 'none',
  },

  '&:disabled': {
    cursor: 'not-allowed',
    backgroundColor: '$black5',
    boxShadow: 'none',
    border: 'solid 1px $black10',
  },

  variants: {
    color: {
      translucent: {
        backgroundColor: '$white20',
        backdropFilter: 'blur(10px)',
        color: '$white100',
        '&:focus, &[data-active=true]': {
          backgroundColor: '$white100',
          color: '$black100',
        },
      },
      white: {
        backgroundColor: '$white100',
        color: '$black100',
        border: 'solid 1px $black10',
      },
      gray: {
        color: '$black100',
        backgroundColor: '$black5',
        '&:focus, &[data-active=true]': {
          backgroundColor: '$black10',
          '@bp2': {
            backgroundColor: '$white100',
          },
        },
      },
    },
    size: {
      large: {
        $$shadowColor: 'rgba(0, 0, 0, 0.05)',
        $$strokeColor: 'transparent',
        $$borderColor: '$colors$black100',
        $$placeholderColor: '$colors$black50',
        $$placeholderFocusColor: '$colors$black100',
        border: 'none',
        boxShadow: '0px 0px 0px 1px $$strokeColor',
        '&::placeholder': {
          color: '$$placeholderColor',
          fontSize: '$1',
          opacity: 1,
        },
        '&:focus, &[data-active=true]': {
          '&::placeholder': {
            color: '$$placeholderFocusColor',
          },
        },
      },
    },
  },
  compoundVariants: [
    {
      color: 'white',
      size: 'large',
      css: {
        $$strokeColor: 'rgba(0, 0, 0, 0.1)',
      },
    },
    {
      color: 'translucent',
      size: 'large',
      css: {
        $$placeholderColor: '$colors$white100',
      },
    },
  ],
});

export default Input;
